<template>
    <div class="identify-viewer">
        <div class="row" v-if="emptyPage">
            <div class="col">
                <div class="alert alert-primary" role="alert">
                    {{ $t(`${idPanel}.result.no_data`) }}
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col">
                <div class="identify-view-container">
                    <div class="identify-slider-view" :class="containerClass" >
                        <div
                            class="panel panel-default"
                            v-for="(res, idx) in validResponses"
                            :key="`identify-view-${idx}`"
                            v-show="index==idx">
                            <div class="panel-body">
                                <div class="w-100 h-100 overflowX" >
                                    <component
                                        :is="viewer(res)"
                                        :response="res.response"
                                        :layer="res.layerMetadata"
                                        :activeItemId="activeItemId"
                                        @close="onCloseViewer"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row small mt-3" v-if="emptyLayers">
                        <div class="col">
                            <div class="alert alert-info mb-0" role="alert" v-html="emptyLayers">
                            </div>
                        </div>
                    </div>
                    <div class="row small mt-3" v-if="exceptionLayers">
                        <div class="col">
                            <div class="alert alert-danger mb-0" role="alert" v-html="exceptionLayers">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { isEmpty } from '@config/utils'
    import { getDefaultInfoFormatValue, getValidator, getViewers, getViewer } from '../../catalog/utils/MapInfoUtils';
    import { getFormatForResponse } from '../../catalog/utils/IdentifyUtils';

    export default {
        name: 'IdentifyDefaultViewer',
        mixins: [
        ],
        components: {

        },
        props: {
            index: {
                type: Number,
                default: 0,
            },
            responses: {
                type: Array,
                default: () => [],
            },
            requests: {
                type: Array,
                default: () => [],
            },
            missingResponses: {
                type: Number,
                default: 0,
            },
            format: {
                type: String,
                default: null,
            },
            renderValidOnly: {
                type: Boolean,
                default: false,
            },
            showEmptyMessage: {
                type: Boolean,
                default: true,
            },
            renderException: {
                type: Boolean,
                default: false,
            },
            showExceptionMessage: {
                type: Boolean,
                default: true,
            },
            activeItemId: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                idPanel: 'identify',
            }
        },
        mounted() {

        },
        computed: {
            viewers() {
                return getViewers() || [];
            },
            viewerFormat() {
                return this.format || getDefaultInfoFormatValue();
            },
            validator() {
                return getValidator(this.viewerFormat);
            },
            responseProperties() {
                const validator = this.validator;
                const responses = this.responses.map(res => res === undefined ? {} : res); // Replace any undefined responses
                const validResponses = this.renderValidOnly ? validator.getValidResponses(responses) : responses; //.filter(item => item?.layerMetadata?.features?.length)
                const invalidResponses = validator.getNoValidResponses(this.responses);
                const exceptionResponses = validator.getExceptionResponses(this.responses);
                const emptyResponses = this.requests.length === invalidResponses.length;
                const currResponse = validResponses[this.index];
                return {
                    responses,
                    validResponses,
                    currResponse,
                    emptyResponses,
                    invalidResponses,
                    exceptionResponses
                };
            },
            validResponses() {
                return this.responseProperties.validResponses;
            },
            invalidResponses() {
                return this.responseProperties.invalidResponses;
            },
            emptyResponses() {
                return this.responseProperties.emptyResponses;
            },
            currentResponse() {
                return this.responseProperties.currResponse;
            },
            exceptionResponses() {
                return this.responseProperties.exceptionResponses;
            },
            emptyPage() {
                return this.missingResponses === 0 && this.emptyResponses;
            },
            emptyLayers() {
                if (this.missingResponses === 0 && this.emptyResponses) {
                    return null;
                }
                let allowRender = this.invalidResponses.length !== 0;
                if (!this.renderValidOnly) {
                    allowRender =  allowRender && this.missingResponses === 0;
                }
                if (allowRender) {
                    const titles = this.invalidResponses.map((res) => {
                        const {layerMetadata} = res;
                        return layerMetadata.title;
                    });
                    return this.showEmptyMessage ?
                            `<span>${this.$t(`${this.idPanel}.result.no_data_layers`) } </span><b>${titles.join(', ')}</b>` : null;
                }
                return null;
            },
            exceptionPage() {
                return this.missingResponses === 0 && !this.emptyResponses && this.exceptionResponses.length > 0;
            },
            exceptionLayers() {
                if (this.missingResponses === 0 && this.exceptionResponses.length === 0) {
                    return null;
                }
                let allowRender = this.exceptionResponses.length !== 0;
                if (!this.renderException) {
                    allowRender =  allowRender && this.missingResponses === 0;
                }
                if (allowRender) {
                    const titles = this.exceptionResponses.map((res) => {
                        const {layerMetadata} = res;
                        return layerMetadata.title;
                    });
                    return this.showExceptionMessage ?
                            `<span>${this.$t(`${this.idPanel}.result.error_layers`) } </span><b>${titles.join(', ')}</b>` : null;
                }
                return null;
            },
            containerClass() {
                return isEmpty(this.currentResponse) ? 'd-none' : 'd-block';
            },
        },
        methods: {
            viewer(res) {
                const {response, layerMetadata} = res;
                const format = getFormatForResponse(res, {format: this.viewerFormat});
                let customViewer;
                if (layerMetadata?.viewer?.type) {
                    customViewer = getViewer(layerMetadata.viewer.type);
                }
                return customViewer || this.viewers[format];
            },
            onCloseViewer(args={}) {
                this.$emit('close', args)
            }
        },
    }

</script>

<style scoped lang="scss">

</style>